import {
  getDeviceInfo,
  getHeytapID,
  getClientContext,
  isWallet,
} from './fintechUtil';
import { query } from '@js/utils';
//单例模式获取wv中数据，获取过直接返回，没值取一次放在类的函数上用作私有变量

export class BrowserBridgeHandler {
  /**
   * 获取IflowSession数据 不缓存 防止用户登录回来后没获取到登录后的IflowSession
   * 因为部分机型页面 visibilitychange 监听不到
   * @returns
   */
  static getIflowSession() {
    if (process.env.NODE_ENV === 'development') {
      return 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1dHlwIjoxLCJidWlkIjozNTMwMDE2Njk1MDI1MDExMjAsImF1ZCI6ImJyb3dzZXIiLCJ2ZXIiOjIsInJhdCI6MTU4NTg5NTMzNiwidW5tIjoiT1BQT181NTk4MDkzODQiLCJpZCI6IjU1OTgwOTM4NCIsImV4cCI6MTY0OTA2Mjk3NSwiZGMiOiJ0ZXN0In0.1o_uEVpGopbqFds4_CIR7m4ZVN0I4HoVoNTmZ7ORCOk';
    }
    return window.wv.getIflowSession() || '';
  }
  /**
   * 获取session数据 不缓存 防止用户登录回来后没获取到登录后的session
   * 因为部分机型页面 visibilitychange 监听不到
   * @returns
   */
  static getSession() {
    return window.wv.getSession()?.data || '';
  }
  static isObject(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
  }

  static isDef(o) {
    return typeof o !== 'undefined';
  }

  /**
   * 获取转base64后的session数据 不缓存 防止用户登录回来后没获取到登录后的session
   * 因为部分机型页面 visibilitychange 监听不到
   * @returns
   */
  static getBtoaSession() {
    let _btoaSession = this.getSession();
    if (this.isObject(_btoaSession)) {
      _btoaSession = window.btoa(JSON.stringify(_btoaSession));
    } else {
      _btoaSession = '';
    }
    if (process.env.NODE_ENV === 'development') {
      _btoaSession =
        'eyJ5aWRpYW4iOiJKU0VTU0lPTklEPXJtRHFrbm41bUJvWTZhX2pTb0ZMNHc7LTI1NDczMDM5ODgiLCJzIjoib3BwbyIsIm9wcG8iOiJvZnM9ZXlKMGVYQWlPaUpLVjFRaUxDSmhiR2NpT2lKSVV6STFOaUo5LmV5SjFkSGx3SWpveExDSmlkV2xrSWpvek5UTXdNREUyTmprMU1ESTFNREV4TWpBc0ltRjFaQ0k2SW1KeWIzZHpaWElpTENKMlpYSWlPaklzSW5KaGRDSTZNVFU0TlRnNU5UTXpOaXdpZFc1dElqb2lUMUJRVDE4MU5UazRNRGt6T0RRaUxDSnBaQ0k2SWpVMU9UZ3dPVE00TkNJc0ltVjRjQ0k2TVRZME9UQTJNamszTlN3aVpHTWlPaUowWlhOMEluMC4xb191RVZwR29wYnFGZHM0X0NJUjdtNFpWTjBJNEhvVm9OVG1aN09SQ09rIiwiaW5mbyI6eyJydCI6IjE2NDg2MzA5NzUiLCJmdCI6IjE1ODU4OTUzMzYiLCJkZnQiOjE2NDg2MzA5NzUsInVuIjoiT1BQT181NTk4MDkzODQiLCJ1dWlkIjoiODZjMGRiOGQ2ZjkwNjVlNzBiYjUyY2ZhYWQ0ZWUzZDQiLCJidXVpZCI6MzUzMDAxNjY5NTAyNTAxMTIwfX0=';
    }
    return _btoaSession;
  }

  static async getBrowserInfo() {
    if (this._browserInfo) {
      return this._browserInfo;
    }

    if (isWallet()) {
      const devicesInfo = (await getDeviceInfo()) || {};
      const heytapID = (await getHeytapID()) || {};
      const clientContext = (await getClientContext()) || {};
      // oaid=ouid，udid=guid，vaid=duid
      this._browserInfo = {
        androidApiVersion: 0,
        androidIdMd5: devicesInfo.androidId,
        androidReleaseVersion: devicesInfo.os,
        brand: devicesInfo.phoneMarker,
        browserVersion: devicesInfo.appVersion,
        colorOsVersion: clientContext.ColorOsVersion,
        deviceType: '',
        duid: heytapID.vaid || heytapID.duid || '', // 目前没有duid
        udid: heytapID.udid || '',
        imei: devicesInfo.imei,
        mobileName: devicesInfo.model,
        mobileRomVersion: clientContext.romBuildDisplay || '',
        networkType: devicesInfo.internetType,
        ouid: heytapID.oaid,
        ouidStatus: '',
      };
    } else if (window.pageData?.isCommonSdk) {
      this._browserInfo =
        JSON.parse(window.BrowserPriv?.getBrowserInfo?.() || null) || {};
    } else {
      this._browserInfo = window.wv.getBrowserInfo?.()?.data;
    }
    return this._browserInfo || {};
  }

  // 获取ua信息，针对端外场景，如：锁屏、天气、小布等等
  // 此次只针对锁屏场景，不同应用ua规则不一致
  static getUserAgent() {
    const uaInfo = window.navigator.userAgent.toUpperCase();
    let brandName;
    if (uaInfo.indexOf('CHANNEL/REALME') > -1) {
      brandName = 'REALME';
    } else if (uaInfo.indexOf('CHANNEL/ONEPLUS') > -1) {
      brandName = 'ONEPLUS';
    }
    // 从链接获取品牌
    return brandName || query.get('__brand__') || 'OPPO';
  }

  // 获取三品牌信息(包含端内/端外)
  static async getBrand() {
    let brandName =
      (await this.getBrowserInfo())?.brand?.toUpperCase() ||
      this.getUserAgent();
    return brandName;
  }

  /**
   * 获取客户端配置
   * @param {*} name 配置名
   */
  static getClientConfigValue(name) {
    let config = '';
    try {
      if (window.wv.isMethodValid('getConfigValue')) {
        config = window.wv.getConfigValue(name).data || '';
      } else {
        console.error(
          `版本过低,调用wv.getConfigValue()失败,无法获取${name}配置`,
        );
      }
    } catch (error) {
      console.log(`解析${name}配置出错:`, error);
    }
    return config;
  }

  static getArticleFoldConfig() {
    if (this._articleFoldConfig) {
      return this._articleFoldConfig;
    }
    let articleFoldConfig =
      this.getClientConfigValue('CommonConfig_detailPageArticleFold') || {};

    if (process.env.NODE_ENV === 'development') {
      articleFoldConfig = {
        switch: {
          oppo: 1,
          yidian: 1,
          toutiao: 1,
        },
        startFoldPos: 1,
        condition: {
          or: {
            // "sceneList": ["push", "list",],
            // "sceneList": ["push",],
            sceneList: ['list'],
            // "query": [{ "key": "__channel__", }]
          },
          minArticleHeight: 2,
        },
      };
    }
    return (this._articleFoldConfig = articleFoldConfig) || {};
  }
}
